import { PermissionsEnum } from './enums';

const hasPermission = (allScopes, scope) =>
  allScopes.includes(scope) || allScopes.includes(PermissionsEnum.all);

// eslint-disable-next-line import/prefer-default-export
export { hasPermission };
